import { type MedicalGroupDetail, createMedicalGroupDetail } from 'models';
import { useMutation } from 'query';
import { getMedicalGroupDetail } from '../../services';

type MedicalGroupDetailParameters = {
  id: string;
};

export const useMedicalGroupDetail = () =>
  useMutation<MedicalGroupDetail, MedicalGroupDetailParameters>({
    async mutationFn({ id }: MedicalGroupDetailParameters) {
      const { data } = await getMedicalGroupDetail({ routeParams: { id } });

      return createMedicalGroupDetail(data);
    },
  });
